module.exports = __webpack_public_path__ + "img/googlepay.54b388b9.png";